import store from '@/store/index';

export default {
    methods: {
        hasPermission(permission) {
            return store.getters.hasPermission(permission);
        },
        hasRole(role) {
            return store.getters.hasRole(role);
        },
        hasAtLeastOneRole(roles) {
            return store.getters.hasAtLeastOneRole(roles);
        },
        hasEveryPermissions(permissions) {
            return store.getters.hasEveryPermissions(permissions);
        },
        shouldShowLink(routeName) {
            return store.getters.hasAccessToRoute(routeName);
        },
    },
};
